export default Object.freeze({
    LOADING: 'Carregando...',
    YES: 'Sim',
    NO: 'Não',
    CLOSE: 'Fechar',
    FILTER: 'Filtrar',
    CLEAR: 'Limpar',
    INFO: 'Info',
    OR: 'ou',
    OK: 'OK',
    RESTART: 'Reiniciar',
    INSTRUCTIONS: 'Instruções',
    COUNT: 'Contagem',
    AUTHORSHIP: 'Autoria de ',
    APP_ON_PLAY_STORE: 'Aplicativo na Play Store',
    APP_ON_APPLE_STORE: 'Aplicativo na Apple Store',
    CANCEL: 'Cancelar',
    CONFIRM_LOGOUT: 'Sair do aplicativo',
    DRUGS_NO_DATA: "Nenhum medicamento encontrado para a busca informada.",
    PATIENTS_NO_DATA: "Nenhum paciente ou tutor encontrados para a busca informada.",
    PATIENTS_TYPE_3_LETTERS: "Digite pelo menos 3 letras para buscar pacientes ou tutores.",
    SIGN_NO_DATA: "Sinal clínico não encontrado.",
    NO_DATA: 'Nenhuma informação encontrada',
    SELECT_A_PATIENT_FOR_RECORDS: "Selecione ou crie um paciente para acessar o prontuário.",
    ADDENDA: 'Adendos',
    SEE_RESULTS: 'Ver resultados',
    SEE_DRUG: 'Ver medicamento',
    SEE_MORE: 'Ver mais',
    RESULTS: 'Resultados',
    CONTINUE: "Continuar",
    CONTINUE_WITH_RECORDS: "Continuar com prontuário",
    START: "Começar",
    MY_DATA: 'Meus Dados',
    BACK: 'Voltar',
    EDIT: 'Editar',
    EDIT_MY_ACCOUNT: "Editar meus Dados",
    CATEGORY: 'Categoria',
    CATEGORIES: 'Categorias',
    CONTENTS: 'Conteúdos',
    TRENDS: 'Novidades',
    VA_PRO: 'Vet Alfa PRO',
    MY_SUBSCRIPTION: 'Minha Assinatura',
    SHARE_DUO_PLAN: 'Compartilhar Assinatura',
    SHARED_SUBSCRIPTION: 'Assinatura Compartilhada',
    DETAILS: 'Detalhes',
    NO_NAME: 'Sem nome cadastrado',
    CLICK_TO_EDIT: "Clique para editar",
    SHARE: "Compartilhar",
    FAVORITE: "Favoritar",
    MY_FAVORITES: "Meus Favoritos",
    DOSES_LABEL: 'Doses',
    PRODUCTS_BACK_BUTTON: 'Produtos',
    ACTIVE_PRINCIPLE: 'Princípios Ativos',
    ACTIVE_PRINCIPLE_SINGULAR: 'Princípio Ativo',
    ALLOWED_ANIMALS: 'Animais',
    ALLOWED_ANIMALS_APPLICATION: 'Aplicações permitidas em',
    CALCULATORS: 'Calculadoras',
    SEARCH_TEXT: 'Buscar',
    RECENT_SEARCHES: 'Buscas recentes',
    SEARCH_WHAT_YOU_WANT: "O que você deseja encontrar?",
    WHERE: 'em',
    TREATMENT: 'Tratamento',
    COMPLETE_APPROACH: 'Abordagem Completa',
    TUTOR: "Tutor",
    PATIENT_RECORD: "Prontuário",
    NEW_ENCOUNTER: "Nova consulta",
    ENCOUNTER: "Consulta",
    ENCOUNTERS: "Consultas",
    CHIEF_COMPLAINT: "Queixa principal",
    PATIENT_ADDITIONAL_INFO: "Informações adicionais do paciente (opcional)",
    MICROCHIP: "Microchip",
    COLOR: "Cor/Pelagem",
    NEUTERED: "Castrado",
    BLOOD_TYPE: "Tipo sanguíneo",
    CHRONIC_CONDITIONS: "Condições crônicas",
    INSURANCE_PROVIDER: "Plano de saúde pet",
    NEUTERED_QUESTION: "O paciente é castrado?",
    NO_ENCOUNTER_ADDED: "Nenhuma consulta registrada para este paciente.",
    RETURN: "Retorno",
    EMERGENCY: "Emergência",
    HOSPITALIZATION: "Internação",
    FINISHED: "Finalizada",
    FINALIZE_ENCOUNTER: "Finalizar consulta",
    FINALIZE_ENCOUNTER_CONFIRM: "Ao finalizar, a consulta passa a ser um registro clínico definitivo.<br><br>O conteúdo não poderá mais ser editado nem excluído. Correções posteriores só serão possíveis por meio de adendos.<br><br>Deseja finalizar esta consulta?",
    FINALIZE_ENCOUNTER_CONFIRM_ACTION: "Finalizar consulta",
    ENCOUNTER_FINALIZED_SUCCESS: "Consulta finalizada com sucesso.",
    ENCOUNTER_FINALIZED_BY: "Finalizada por",
    ENCOUNTER_READ_ONLY: "Consulta finalizada. O conteúdo não pode mais ser alterado.",
    ENCOUNTER_FINALIZE_WITHOUT_SAVE: "A consulta não foi finalizada porque nem tudo foi salvo. Corrija os itens acima e tente novamente.",
    ENCOUNTER_FINALIZE_FORBIDDEN: "Você não pode finalizar registros clínicos. Verifique se o seu CRMV e UF estão cadastrados e se o seu perfil não é de estudante.",
    ENCOUNTER_FINALIZE_CONFLICT: "Esta consulta já está finalizada e não pode mais ser alterada.",
    ENCOUNTER_FINALIZE_ERROR: "Não foi possível finalizar a consulta. Tente novamente.",
    ENCOUNTER_UNSAVED_SECTIONS: "Não foi possível salvar:",
    ENCOUNTER_UNSAVED_CHANGES: "Existem alterações não salvas nesta consulta. Deseja sair mesmo assim?",
    ENCOUNTER_LEAVE_ANYWAY: "Sair sem salvar",
    ADD_ADDENDUM: "Adicionar adendo",
    ADDENDUM: "Adendo",
    ADDENDUM_TEXT: "Texto do adendo",
    ADDENDUM_HINT: "O adendo é acrescentado ao registro finalizado e não altera o conteúdo original.",
    ADDENDUM_SAVED: "Adendo adicionado com sucesso.",
    ADDENDUM_ERROR: "Não foi possível adicionar o adendo. Tente novamente.",
    NO_ADDENDA: "Nenhum adendo registrado.",
    PATIENT_NOT_FOUND: "Paciente não encontrado.",
    PATIENT_ACCESS_DENIED: "Você não tem acesso a este paciente.",
    ENCOUNTER_TYPE: "Tipo da consulta",
    ANAMNESIS: "Anamnese",
    PHYSICAL_EXAM: "Exame físico",
    DIAGNOSIS: "Diagnóstico",
    DIAGNOSES: "Diagnósticos",
    DIAGNOSIS_NAME: "Nome do diagnóstico",
    DIAGNOSIS_TYPE: "Tipo",
    DIAGNOSIS_STATUS: "Status",
    DIAGNOSIS_DEFINITIVE: "Definitivo",
    DIAGNOSIS_PRESUMPTIVE: "Presuntivo",
    DIAGNOSIS_DIFFERENTIAL: "Diferencial",
    DIAGNOSIS_ACTIVE: "Ativo",
    DIAGNOSIS_RESOLVED: "Resolvido",
    ADD_DIAGNOSIS: "Adicionar diagnóstico",
    ADD_FROM_DDX: "Adicionar via DDx",
    NO_DIAGNOSIS_ADDED: "Nenhum diagnóstico adicionado.",
    PROBLEM_LIST: "Problemas do paciente",
    NO_PROBLEMS: "Nenhum problema registrado.",
    HISTORY: "Histórico",
    CURRENT_MEDICATIONS: "Medicamentos em uso",
    ALLERGIES: "Alergias",
    DIET: "Dieta",
    ENVIRONMENT: "Ambiente",
    REPRODUCTIVE_STATUS: "Status reprodutivo",
    PREVIOUS_DISEASES: "Doenças anteriores",
    VACCINATION_STATUS: "Status vacinal",
    NOTES: "Observações",
    TEMPERATURE: "Temperatura (°C)",
    HEART_RATE: "Frequência cardíaca (bpm)",
    RESPIRATORY_RATE: "Frequência respiratória (mpm)",
    MUCOUS: "Mucosas",
    CRT: "TPC",
    HYDRATION: "Hidratação",
    LYMPH_NODES: "Linfonodos",
    BODY_SCORE: "Escore corporal (1-9)",
    CONSCIOUSNESS: "Estado de consciência",
    SYSTEMS_FINDINGS: "Achados por sistema",
    OUT_OF_RANGE: "Fora do intervalo esperado",
    SAVE: "Salvar",
    ADD_PRESCRIPTION: "Adicionar prescrição",
    COMPLETE_APPROACH_DISEASES_TIMELINE_ITEM: 'Doença: Abordagem Completa',
    NOVELTIES: 'Novidades',
    KNOW_MORE: 'Saiba mais',
    CHOSEN_PA: 'Princípios ativos escolhidos:',
    ADDRESS: 'Endereço',
    FOOD_PET_SIZES: 'Portes',
    FOOD_PET_AGES: 'Idades',
    PET_BREEDS: 'Raças',
    BREED: 'Raça',
    FOOD_TYPE: 'Tipo de Alimento',
    FOOD_CLASSES: 'Indicações Terapêuticas',
    FEATURES: 'Características',
    foodPresentation: function (presentation) { return `Alimento ${presentation} disponível em:` },

    EMAIL_HEADER_LOGIN: 'Entrar com o e-mail',
    EMAIL_HEADER_ENTER_PASSWORD: 'Confirme sua senha',
    EMAIL_HEADER_CREATE_PASSWORD: 'Cadastrar nova senha',
    EMAIL_HEADER_CONFIRM_EMAIL: 'Confirme seu e-mail',
    EMAIL_BODY_LOGIN: 'Digite seu e-mail:',
    EMAIL_INPUT_LABEL: 'E-mail',
    EMAIL_INPUT_PASSWORD: 'Senha',
    EMAIL_INPUT_NEW_PASSWORD: "Nova senha",
    EMAIL_INPUT_AGAIN_LABEL: 'Insira seu e-mail novamente',
    EMAIL_INPUT_AGAIN_PASSWORD: 'Insira a nova senha novamente',

    DOSES_TAB_SECTION_TITLE: 'Indicações',
    VETERINARY_PRODUCTS: 'Medicamentos Veterinários',
    VETERINARIANS: 'Veterinários',
    VETERINARY: 'Veterinário',
    HUMAN_PRODUCTS: 'Medicamentos Humanos',
    HUMANS: "Humanos",
    HUMAN: "Humano",
    PRESENTATION: 'Apresentações',
    REFERENCES: 'Referências',
    INTERNAL_REFERENCES: 'Referências Vet Alfa',
    EXTERNAL_REFERENCES: 'Referências externas',
    EXTERNAL: 'Externas',
    SIGNUP_DISPLAY_NAME: "Qual o seu nome completo?",
    SIGNUP_DISPLAY_NAME_PREFIX: "Por qual prefixo você gostaria de ser chamado? Este prefixo aparacerá nos documentos enviados para seus pacientes. (Opcional)",
    PREFIX: "Prefixo",
    SIGNUP_NATIONALITY: "Escolha o país onde você nasceu:",
    SIGNUP_NATIONALITY_BRAZILIAN: "Você possui nacionalidade brasileira?",
    CPF: 'CPF',
    SIGNUP_CPF: 'Qual o seu CPF?',
    OWNER_CPF: 'Qual o CPF do Tutor?',
    OWNER_ADDRESS: 'Endereço do Tutor (Opcional)',
    SIGNUP_CPF_HINT: 'Digite os 11 números do CPF válido.',
    DATE: 'Data',
    BIRTHDAY: 'Data de Nascimento',
    SIGNUP_BIRTHDAY: 'Qual a data do seu nascimento?',
    SIGNUP_BIRTHDAY_ERROR: 'Data inválida. Lembre-se, para cadastrar você precisar ter pelo menos 18 anos.',
    INVALID_DATE: 'Data inválida',
    YEARS: 'anos',
    PHONE: 'Telefone',
    PHONE_LABEL: 'Digite o telefone com DDD (Opcional)',
    NAME: 'Nome',
    NAME_ERROR: 'Nome inválido. Informe o nome completo sem abreviações.',
    SURNAME: "Sobrenome",
    NATIONALITY: "Nacionalidade (País)",
    BRAZIL: "Brasil",
    LOGIN_FOOTER_TEXT_1: 'Usando o Vet Alfa, você aceita os ',
    LOGIN_FOOTER_TEXT_2: ' e as ',
    ABOUT: 'Sobre',
    USE_TERMS_TITLE: 'Termos de Uso',
    PRIVACY_POLICIES_TITLE: 'Políticas de Privacidade',
    SLOGAN: 'Suporte à Decisões Clínicas Baseado em Evidências.',
    DRUGS_BRANDS: "Marcas",
    NO_CONTENT: 'Nenhum resultado encontrado. Experimente refinar sua busca com termos mais específicos ou outras palavras-chave.',
    NO_FAVORITES: 'Você não possui conteúdos favoritados.',
    NO_SEARCH: "Digite e busque por qualquer conteúdo disponível.",
    SEARCH_OR_SUGGEST_CONTENT: 'Clique para buscar em todas categorias ou para sugerir um novo conteúdo.',
    SUGGEST_CONTENT: 'Clique em sugerir e colabore com a comunidade Vet Alfa.',
    SEARCH_ON_VET_ALFA: 'Buscar em todo Vet Alfa',
    SUGGEST_CONTENT_BTN: 'Sugerir novo conteúdo',

    QUESTIONS_FIRST_STEP_EDITION: 'Vamos completar seu cadastro',
    QUESTIONS_SECOND_STEP: 'Conte-nos mais sobre você...',
    QUESTIONS_FIRST_STEP: 'Boas-vindas ao Vet Alfa!',
    QUESTIONS_THIRD_STEP: 'Falta pouco!',
    QUESTIONS_FOURTH_STEP: 'Ufa, chegamos na última pergunta',
    QUESTIONS_FIRST_TOPIC_EDITION: 'Insira abaixo as informações solicitadas.',
    QUESTIONS_FIRST_TOPIC: 'Para continuar, vamos completar o seu cadastro.',
    QUESTIONS_SECOND_TOPIC: 'Qual a sua relação com a medicina veterinária?',
    QUESTIONS_PROFESSIONAL: 'Profissional',
    QUESTIONS_STUDENT: 'Graduando',
    QUESTIONS_OTHERS: 'Outros',
    QUESTIONS_PROFESSIONAL_TOPIC: 'Onde você fez sua graduação e quais são as suas formações acadêmicas adicionais?',
    QUESTIONS_STUDENT_TOPIC: 'Onde você está estudando e qual a sua previsão de formatura?',
    QUESTIONS_GRADUATION_YEAR: 'Previsão de formatura',
    QUESTIONS_SCHOOL: 'Instituição de ensino',
    QUESTIONS_NIVELS: 'Formações acadêmicas',
    QUESTIONS_OTHERS_TOPIC: 'Qual a sua ocupação?',
    OCUPATION_AND_ACADEMIC_INFO: 'Ocupação, Formações e Preferências',
    QUESTIONS_OCUPATION: 'Ocupação',
    QUESTIONS_FOURTH_TOPIC: 'Quais são suas áreas de interesse?',
    QUESTIONS_CONFIRM: 'Salvar respostas',
    QUESTIONS_SELECT_PLACEHOLDER: 'Selecione',
    QUESTIONS_KEEP_AWNSERING: 'Continuar a responder',
    QUESTIONS_CLOSE_SAVE: 'Encerrar questionário',
    QUESTIONS_ASK_KEEP_AWNSERING: 'Deseja sair e encerrar o questionário?',
    REFERENCE_CARD_NAME: 'Nome',
    REFERENCE_CARD_YEAR: 'Ano',
    REFERENCE_CARD_MAGAZINE: 'Revista',
    REFERENCE_CARD_SOURCE: 'Fonte',
    REFERENCE_CARD_EVIDENCE_LEVEL: 'Nível de Evidência',
    REFERENCE_WITHOUT_APPLICATION: 'Não se aplica',
    REFERENCE_GUIDELINE: 'Guideline',
    REFERENCE_WITHOUT_APPLICATION_BOOK: 'livro',
    REFERENCE_CARD_SITE: 'Site',
    REFERENCE_MORE_INFO: 'Para mais informações',
    REFERENCES_LEVELS: 'Níveis de Evidência',
    REFERENCES_KNOW_MORE_SITE: 'https://www.cebm.net/2016/05/ocebm-levels-of-evidence/',
    REFERENCES_WHAT_IS: 'O que são?',
    REFERENCES_WHAT_IS_EXPLANATION: 'Os “níveis de evidência” do CEBM foram produzidos pela primeira vez em 1998 para o Call On Based Evidence, para viabilizar o processo de encontrar evidências apropriadas e seus resultados explícitos. Revisamos os "níveis" à luz de novos conceitos e dados e gostaríamos de receber seus comentários.',
    USER_SECTION_LOGOUT: 'Sair',
    USER_SECTION_CONTACT_WHATSAPP: 'Nos mande um WhatsApp',
    USER_SECTION_CONTACT_INSTAGRAM: 'Nos mande um oi no Instagram',
    USER_SECTION_CONTACT_US: 'Fale conosco',
    HELP_CENTER: 'Central de Ajuda',
    USER_SECTION_SEND_EMAIL: 'Nos mande um e-mail',
    USER_EXCLUSION: 'Excluir minha conta',
    USER_EXCLUSION_MESSAGE: `
    Ao confirmar a exclusão de seus dados e do seu usuário, todos os dados referentes aos seus acessos, cadastro e navegação em nossas plataformas serão excluídos; garantindo o seu direito de controlar seus dados e como eles são utilizados.
    Solicitamos que você só confirme a exclusão caso tenha certeza absoluta de que quer tomar esta ação. Esta ação é irreversível e não será possível restaurar seus dados após a conclusão.
    Em caso de confirmação da deleção processaremos sua solicitação em até 15 dias úteis.
    Após o período supracitado, você não conseguirá acessar os nossos serviços com conta referida e deverá criar um novo acesso caso queira utilizar nossos serviços.
    Solicitamos, por gentileza, que não efetue o login/acesso durante o período de 15 dias úteis com o mesmo usuário a ser deletado. Recomendamos, também, que você faça o logout e se desconecte de outros dispositivos conectados a este usuário/cadastro.
    Ao concluir sua solicitação iremos descontinuar o acesso desta conta em todos os dispositivos associados.
    Caso você tenha uma assinatura ativa, por favor faça o cancelamento da mesma na sua conta da Apple Store ou Play Store antes de prosseguir com esta ação. Caso contrário, você só poderá cancelar sua assinatura através da sua loja de aplicativos, seguindo as políticas de cancelmento da Apple e Play Stores.
    `,
    USER_EXCLUSION_NO_ACTION: 'Cancelar',
    USER_EXCLUSION_YES_ACTION: 'Deletar conta',
    USER_EXCLUSION_CHECKBOX: 'Estou de acordo com as informações supracitadas e desejo prosseguir com a exclusão do meu usuário e de todos os meus dados.',
    OPEN_ON_APP_TEXT: "Acesso rápido e evidências a um toque de distância ao acessar pelo aplicativo.",
    OPEN_ON_APP_CONFIRM_TEXT: "Mudar para o aplicativo",
    NOT_NOW: "Agora não",
    TOPICS_MANAGEMENT_CLICK_TO_ADD: 'Clique para criar novo registro.',
    MY_RECENTS: 'Meu Histórico',
    ITEMS_MODES_DRUGS: 'Medicamentos e Vacinas',
    ITEMS_MODES_FOODS: 'Rações',
    ALGORITHMS_TITLE: 'Algoritmos',
    DISEASES_TITLE: 'Doenças',
    DRUGS_INTERACTIONS: 'Interações Medicamentosas',
    DRUGS_INTERACTIONS_DISCLAIMER_1: 'Todas as interações são classificadas conforme os níveis abaixo:',
    DRUGS_INTERACTIONS_DISCLAIMER_2: 'Se nenhuma interação for encontrada, isso não implica que não existam interações.',
    DRUGS_INTERACTIONS_DISCLAIMER_3: 'As interações farmacológicas listadas foram relatadas ou são hipotetizadas em pessoas ou animais e podem ser relevantes em pacientes veterinários.',
    DRUGS_INTERACTIONS_DISCLAIMER_4: 'Salvo contrário, o uso em conjunto não é necessariamente contraindicado. No entanto, avalie os perigos potenciais e faça um monitoramento adicional conforme necessário.',
    DDX_TITLE: 'Diagnósticos Diferenciais',
    FAKE_DOORS_DISEASES_FULL_APPROACH: '<b class="primary--text">Doença: Abordagem Completa</b><br><br>A construção da abordagem completa para este tópico ainda está em progresso.<br><br> Porém, sua curiosidade impulsiona nosso trabalho e garantiremos que este conteúdo seja disponibilizado em breve.<br><br>Gostaria de ser notificado por e-mail quando estiver pronto?',
    FAKE_DOOR_YES: 'Quero receber um aviso',
    FAKE_DOOR_NO: 'Agora não',
    FLASH_CARDS_KEEP_OPEN: "Continuar respondendo",
    FLASH_CARDS_AVERAGE_SCORE_TITLE: "Escore Médio",
    FLASH_CARDS_AVERAGE_UNIQUE_CARDS_ANSWERED: "Cards Únicos Respondidos",
    FLASH_CARDS_SEE_RESULTS: "Revelar Resposta",
    FLASH_CARDS_SCORE: "Escore",
    HOW_IT_WORKS_QUESTION: "Como funciona?",
    FLASH_CARDS_CATEGORIES_SELECTION_TEXT: "Qual categoria você deseja escolher?",
    FLASH_CARDS_SELECTION_TYPE: "Como você deseja responder?",
    FLASH_CARDS_CLASSES_SELECTION_RADIO: "Por assunto",
    FLASH_CARDS__SINGLE_ITEM_SELECTION_RADIO: "Por conteúdo específico",
    FLASH_CARDS_CLASSES_SELECTION_TEXT: "Qual assunto você deseja escolher?",
    FLASH_CARDS_SELECT_SINGLE_ITEM_LABEL: 'Qual conteúdo você deseja escolher?',
    DISEASES_AND_TREATMENT: 'Doenças e Tratamento',
    SYSTEMIC_DRUGS: 'Medicamentos Sistêmicos',
    DERMATOLOGICAL_TOPICS: 'Dermatológicos Tópicos',
    OPTHALMIC_AGENTS: 'Agentes Oftalmológicos',
    PROGRESS: "Progresso",
    NOT_STARTED: "Não iniciado",
    VA_CARDS: "Flashcards",
    ALL: "Todas",
    SELECT_AND_CONTINUE: "Selecionar e continuar",
    SELECT_AND_VIEW: "Selecionar e visualizar",
    REVIEW_SEND: "Revisar e Enviar",
    SELECT_ONLY: "Apenas selecionar",
    ALPHABETICAL_ORDER: "Ordem alfabética",
    BIGGER_PROGRESS: "Maior progresso",
    SMALLER_PROGRESS: "Menor progresso",
    BIGGER_SCORE: "Maior escore",
    SMALLER_SCORE: "Menor escore",
    SORT_BY: "Classificar por",
    LEAVE_SHARE_SUBSCRIPTION: "Sair da assinatura",
    CANCEL_SHARE_SUBSCRIPTION: "Encerrar compartilhamento",
    CLINICAL_HANDOUTS: "Folhetos do Tutor",
    CLINICAL_HANDOUTS_SHARE: "Compartilhar folhetos",
    CLINICAL_HANDOUT_SHARE: "Compartilhar folheto",
    CLINICAL_HANDOUTS_SELECT_MORE: "Selecionar mais folhetos",
    CLINICAL_HANDOUTS_SELECTED: "Folhetos do tutor selecionados",
    TUTOR_EMAIL: "E-mail do tutor",
    TUTOR_EMAIL_OPTIONAL: "E-mail do tutor (Opcional)",
    TUTOR_NAME: "Nome completo do tutor",
    OWNERS_NO_DATA: "<b>As informações deste link não foram encontradas ou ele expirou.</b><br><br> Por favor, confira o link compartilhado com você ou tente novamente mais tarde. <br><br> Caso o problema persista, entre em contato com seu médico veterinário e solicite que ele compartilhe o link novamente.",
    CANCEL_SUBSCRIPTION: "Cancelar assinatura",
    PURCHASES_DISCLAIMER_GOOGLE: "Cancele a qualquer momento na Google Play. ",
    PRESCRIPTIONS: "Prescrições",
    SEARCH_DRUG: "Busque o medicamento desejado",
    ADD_ITEM: "Adicionar Item",
    PRESCRIPTIONS_SEARCH: "Bucar medicamentos",
    PRESCRIPTIONS_WHICH_DOSE_QUESTION: 'Qual dose você deseja utilizar?',
    PRESCRIPTIONS_SELECT_DOSE: "Clique para selecionar a dose (opcional)",
    EXPAND_CALCULATOR: "Clique para ver a calculadora (opcional)",
    PRESCRIPTIONS_WHICH_DISPLAY_QUESTION: 'Qual apresentação você deseja utilizar?',
    PRESCRIPTIONS_SELECT_DISPLAY: "Clique para selecionar a apresentação",
    OWNERS: "Tutores",
    SPECIES: "Espécie",
    PATIENTS: 'Pacientes',
    PATIENTS_OWNER_SEARCH: 'Busque pelo nome do paciente ou tutor',
    PATIENT_NAME: 'Nome do paciente',
    PATIENT_SPECIES: 'Qual a espécie do seu paciente?',
    PATIENT_SEX: 'O paciente é macho ou fêmea?',
    PATIENT_WEIGHT: 'Qual o peso do paciente (kg)?',
    PATIENT_HAS_BIRTHDAY: 'O paciente possui data de nascimento?',
    PATIENT_HAS_BIRTHDAY_NO: 'Não - Tutor desconhece a data de nascimento exata.',
    PATIENT_HAS_BIRTHDAY_YES: 'Sim - Tutor sabe a data de nascimento do paciente.',
    SEARCH_PATIENTS_AND_OWNERS: 'Buscar pacientes e tutores',
    PATIENT_AGE: 'Idade do paciente (anos)',
    PATIENT_BREED: 'Selecione a raça do paciente',
    BREED_ERROR: 'Raça inválida. Informe a raça do paciente.',
    DOG: 'Cão',
    CAT: 'Gato',
    MALE: 'Macho',
    FEMALE: 'Fêmea',
    SEX: 'Sexo',
    WEIGHT: 'Peso',
    WEIGHT_ERROR: 'Peso inválido. Informe o peso do paciente em quilogramas.',
    AGE_ERROR: 'Idade inválida. Informe a idade do paciente em anos.',
    AGE: 'Idade',
    ADD_NEW_PATIENT: 'Adicionar novo paciente',
    ADD_OWNER: 'Adicionar tutor',
    SELECT_PATIENT: 'Selecionar o paciente',
    CLICK_TO_SELECT_PATIENT: 'Clique para selecionar o paciente',
    SEARCH_OTHER_PATIENT: 'Buscar outro paciente',
    PATIENT_SELECTED: 'Paciente selecionado: {1}',
    ADD_FREE_TEXT: "Adicionar manualmente",
    NO_PATIENT_ADDED_FOR_THIS_OWNER: "Nenhum paciente adicionado para este tutor.",
    NO_PRESCRIPTION_ADDED_FOR_THIS_PATIENT: "Nenhuma prescrição adicionada para este paciente.",
    START_PRESCRIPTION: "Iniciar prescrição",
    PRESCRIPTION_MEDICAL_REGISTRATION_DETAILS: 'Você é profissional veterinário e possui CRMV ativo? <br><br> Apenas veterinários graduados com CRMV ativo podem prescrever medicamentos. <br><br> Selecione a opção <b>Possuo CRMV ativo</b> para continuar ou clique em Voltar para retornar.',
    HANDOUTS_MEDICAL_REGISTRATION_DETAILS: 'Você é profissional veterinário e possui CRMV ativo? <br><br> Apenas veterinários graduados com CRMV ativo podem compartilhar folhetos com tutores. <br><br> Selecione a opção <b>Possuo CRMV ativo</b> para ir para a tela de registro ou clique em Cancelar para retornar.',
    HAS_CRMV: 'Possuo CRMV ativo',
    ADDRESS_ZIP_CODE: "Qual o CEP do seu endereço?",
    ADDRESS_STREET_COMERCIAL: 'Logradouro Comercial',
    ADDRESS_STREET: 'Logradouro',
    ADDRESS_NUMBER: 'Qual o número?',
    ADDRESS_COMPLEMENT: 'Complemento (opcional)',
    ADDRESS_NEIGHBORHOOD: 'Bairro',
    ADDRESS_CITY: 'Cidade',
    ADDRESS_STATE: 'Estado',
    ADDRESS_COUNTRY: 'País',
    UNCERTAIN: 'Incerto',
    OWNER_HAS_CPF_QUESTION: 'O tutor possui CPF para informar agora?',
    OWNER_HAS_CPF_YES: 'Sim, preencher CPF',
    OWNER_HAS_CPF_LATER: 'Preencher depois',
    OWNER_ADDRESS_LEGACY: 'Endereço (antigo)',
    PATIENT_MICROCHIP_QUESTION: 'O paciente possui microchip?',
    PATIENT_MICROCHIP_NUMBER: 'Número do microchip (opcional)',
    PATIENT_GOV_REGISTRY_QUESTION: 'O paciente possui Registro Geral Animal (GOV.BR / SinPatinhas)?',
    PATIENT_GOV_REGISTRY_NUMBER: 'Número do Registro (opcional)',
    PATIENT_OTHER_REGISTRY_QUESTION: 'O paciente possui Registro Geral Animal de outro órgão ou instituição?',
    PATIENT_OTHER_REGISTRY_ORGAN: 'Qual o órgão ou instituição? (opcional)',
    PATIENT_OTHER_REGISTRY_NUMBER: 'Número do Registro (opcional)',
    PATIENT_INSURANCE_QUESTION: 'O paciente possui plano de saúde?',
    INSURANCE_PROVIDER_QUESTION: 'Qual a operadora do plano de saúde? (opcional)',
    INSURANCE_PLAN: 'Nome / Categoria do plano (opcional)',
    INSURANCE_CARD_NUMBER: 'Número da carteirinha (opcional)',
    INSURANCE_CARD_VALIDITY: 'Validade da carteirinha (opcional)',
    PATIENT_BODY_SCORE_QUESTION: 'Qual o escore corporal do paciente?',
    BODY_SCORE_UNDEFINED: 'Indefinido',
    BODY_SCORE_VERY_THIN: 'Muito Magro',
    BODY_SCORE_THIN: 'Magro',
    BODY_SCORE_IDEAL: 'Ideal',
    BODY_SCORE_OVERWEIGHT: 'Sobrepeso',
    BODY_SCORE_OBESE: 'Obeso',
    PATIENT_BREED_NOTES: 'Observações raciais (opcional)',
    NEUTERED_UNCERTAIN: 'Incerto / Indefinido',
    PATIENT_ALLERGIES_STATUS_QUESTION: 'O paciente possui histórico de alergia ou hipersensibilidade?',
    PATIENT_ALLERGIES_AFFIRMED: 'Sim — Tutor afirma que sim',
    PATIENT_ALLERGIES_DENIED: 'Não — Tutor nega histórico',
    PATIENT_ALLERGIES_DETAILS: 'Liste as alergias separadas por vírgula (opcional)',
    PATIENT_CHRONIC_STATUS_QUESTION: 'O paciente possui histórico de condições crônicas?',
    PATIENT_CHRONIC_AFFIRMED: 'Sim — Tutor afirma que sim',
    PATIENT_CHRONIC_DENIED: 'Não — Tutor nega histórico',
    PATIENT_CHRONIC_DETAILS: 'Liste as condições crônicas separadas por vírgula (opcional)',
    CLICK_TO_SELECT_PATIENT: "Clique para selecionar seu Paciente.",
    CLICK_TO_SELECT_PATIENT_DETAILS: "Você pode prescrever, ver dados e o histórico.",
    CLICK_TO_EDIT_YOUR_MEDICAL_REGISTRATION: "Para atualizar seu CRMV, endereço e dados pessoais antes de prescrever, <u>clique aqui</u>.",
    SELECT_A_PATIENT_TO_CONTINUE: "Para iniciar uma prescrição selecione ou crie um paciente.",
    DELETE_DRAFT: "Excluir Prescrição",
    DELETE_DRAFT_CONFIRM: "Toda prescrição iniciada fica salva como rascunho no histórico do seu paciente. Você pode visualiza-la na aba de prescrições do seu paciente. <br><br> Você deseja excluir este rascunho? <br><br> Esta ação é irreversível e irá remover todos os itens adicionados da sua seleção. <br><br> Para confirmar clique em <u>Excluir rascunho</u> ou clique em <u>Cancelar</u> para continuar editando.",
    DELETE_DRAFT_CONFIRM_ACTION: "Excluir rascunho",
    TAB_GUIDE: "Guia",
    TAB_GUIDES: "Nº Guias",
    STATUS: "Status",
    DRAFT: "Rascunho",
    PRESCRIPTION_ITEM_TOTAL: "Itens prescritos",
    SENT: "Enviada",
    PRINT: "Imprimir",
    WHATSAPP: "Compartilhar por WhatsApp",
    VISUALIZE_PRESCRIPTION: "Visualizar Prescrição",
    PRESCRIPTION_SHARE_CONFIRMATION: "Você gostaria de <b>compartilhar esta prescrição com o tutor</b>?<br><br>Você pode compartilhar os arquivos gerados por e-mail, WhatsApp ou imprimi-los.<br><br><b>Atenção:</b> Ao confirmar e clicar em \"Compartilhar\", você não poderá mais editar esta prescrição.",
    TUTOR_EMAIL_CONFIRMATION_BEFORE_SEND: "Antes de enviar, confirme o e-mail do tutor:",
    TUTOR_PHONE_CONFIRMATION_BEFORE_SEND: "Antes de enviar, confirme o telefone do tutor com DDD:",
    INVALID_PHONE: "Telefone inválido. Informe o telefone com DDD.",
    NO_MORE_PRESCRIPTIONS_FOUND: "Não foram encontradas mais prescrições.",
    CPF_ALREADY_REGISTERED: "CPF já cadastrado para outro tutor.",
    REPEAT_PRESCRIPTION: "Repetir prescrição",
    NEW_PRESCRIPTION: "Nova prescrição",
    SEE_COMPLETE_DOSE: "Ver dose completa",
    SEE_VETERINARY_PRESENTATION: "Ver apresentação veterinária",
    SEE_HUMAN_PRESENTATION: "Ver Bula desta Apresentação",
    DOSE_CALCULATOR: "Calculadora de Doses",
    SAVE_FILES: "Salvar arquivos",
    CONTINUE_WITH_HANDOUTS: "Continuar com folhetos",
    CONTINUE_WITH_PRESCRIPTIONS: "Continuar prescrições",
    COMPOSITION: "Composição",
    COMPOSITIONS: "Composições",
    VACCINATION: "Vacina",
    VACCINATIONS: "Vacinas",
    VACCINE_NAME: "Nome da vacina",
    MANUFACTURER: "Fabricante",
    BATCH: "Lote",
    APPLICATION_DATE: "Data de aplicação",
    NEXT_DOSE_DATE: "Data da próxima dose",
    DOSE_NUMBER: "Número da dose",
    PROTOCOL: "Protocolo",
    NEW_VACCINATION: "Nova vacina",
    SAVE_VACCINATION: "Salvar vacina",
    PENDING_VACCINES: "Vacinas pendentes",
    ALL_EVENTS: "Todos",
    ENCOUNTERS_FILTER: "Consultas",
    VACCINATIONS_FILTER: "Vacinas",
    NO_VACCINATION_ADDED: "Nenhuma vacina registrada para este paciente.",
    NO_TIMELINE_ITEMS: "Nenhum registro encontrado para este filtro.",
    LAB_EXAM: "Exame complementar",
    LAB_EXAMS: "Exames complementares",
    LAB_EXAM_NAME: "Nome do exame",
    LAB_EXAM_TYPE: "Tipo do exame",
    LAB_EXAM_STATUS: "Status do exame",
    LAB_EXAM_TYPE_LAB: "Laboratorial",
    LAB_EXAM_TYPE_IMAGE: "Imagem",
    LAB_EXAM_TYPE_OTHER: "Outro",
    LAB_EXAM_STATUS_REQUESTED: "Solicitado",
    LAB_EXAM_STATUS_IN_PROGRESS: "Em andamento",
    LAB_EXAM_STATUS_COMPLETED: "Concluído",
    REQUEST_DATE: "Data da solicitação",
    RESULT_DATE: "Data do resultado",
    NEW_LAB_EXAM: "Novo exame",
    LAB_EXAMS_FILTER: "Exames",
    NO_LAB_EXAM_ADDED: "Nenhum exame registrado para este paciente.",
    ATTACH_FILE: "Anexar arquivo",
    FILES: "Arquivos",
    HOSPITALIZATIONS: "Internações",
    HOSPITALIZATION_REASON: "Motivo da internação",
    HOSPITALIZATION_STATUS_ADMITTED: "Internado",
    HOSPITALIZATION_STATUS_DISCHARGED: "Alta",
    HOSPITALIZATION_STATUS_DECEASED: "Óbito",
    HOSPITALIZATION_STATUS_TRANSFERRED: "Transferido",
    ADMISSION_DATE: "Data de admissão",
    DISCHARGE_DATE: "Data de alta",
    NEW_HOSPITALIZATION: "Nova internação",
    HOSPITALIZATIONS_FILTER: "Internações",
    HIDE_DRAFTS: "Ocultar rascunhos",
    ADD: "Adicionar",
    NO_HOSPITALIZATION_ADDED: "Nenhuma internação registrada para este paciente.",
    PATIENT_ADMITTED: "Paciente internado",
    EVOLUTIONS: "Evoluções",
    ADD_EVOLUTION: "Adicionar evolução",
    EVOLUTION_NOTES: "Notas da evolução",
    MEDICATIONS_ADMINISTERED: "Medicamentos administrados",
    VITAL_SIGNS: "Sinais vitais",
    FILE_SINGULAR: "arquivo",
    FILE_PLURAL: "arquivos",
    EVOLUTION_SINGULAR: "evolução",
    EVOLUTION_PLURAL: "evoluções",
    PRESCRIPTION: "Prescrição",
    PRESCRIPTIONS_FILTER: "Prescrições",
    TIMELINE_TRUNCATED: "Exibindo apenas os registros mais recentes deste paciente.",
    LOAD_MORE_ENCOUNTERS: "Carregar mais consultas",
    FINALIZE: "Finalizar",
    FINALIZED: "Finalizado",
    FINALIZED_BY: "Finalizado por",
    WITH_ADDENDUM: "Com adendo",
    DELETE_RECORD: "Excluir",
    DELETE_RECORD_CONFIRM: "Este registro ainda é um rascunho e será excluído do prontuário do paciente.<br><br>Deseja excluir?",
    DELETE_RECORD_CONFIRM_ACTION: "Excluir registro",
    RECORD_DELETED_SUCCESS: "Registro excluído com sucesso.",
    RECORD_DELETE_ERROR: "Não foi possível excluir o registro. Tente novamente.",
    FINALIZE_RECORD_CONFIRM_ACTION: "Finalizar registro",
    FINALIZE_VACCINATION_CONFIRM: "Ao finalizar, a vacina passa a ser um registro clínico definitivo.<br><br>O conteúdo não poderá mais ser editado nem excluído. Correções posteriores só serão possíveis por meio de adendos.<br><br>Deseja finalizar esta vacina?",
    FINALIZE_LAB_EXAM_CONFIRM: "Ao finalizar, o exame passa a ser um registro clínico definitivo.<br><br>O conteúdo e os laudos anexados não poderão mais ser alterados. Correções posteriores só serão possíveis por meio de adendos.<br><br>Deseja finalizar este exame?",
    RECORD_FINALIZED_SUCCESS: "Registro finalizado com sucesso.",
    RECORD_FINALIZE_FORBIDDEN: "Você não pode finalizar registros clínicos. Verifique se o seu CRMV e UF estão cadastrados e se o seu perfil não é de estudante.",
    RECORD_FINALIZE_CONFLICT: "Este registro já está finalizado e não pode mais ser alterado.",
    RECORD_FINALIZE_ERROR: "Não foi possível finalizar o registro. Tente novamente.",
    VACCINATION_FINALIZE_REQUIRED: "Para finalizar a vacina informe o nome da vacina, o fabricante, o lote e a data de aplicação.",
    LAB_EXAM_FINALIZE_REQUIRED: "Para finalizar o exame preencha o resultado ou anexe um laudo.",
    MANUFACTURING_DATE: "Data de fabricação",
    EXPIRATION_DATE: "Data de validade",
    ATTACH_REPORT: "Anexar laudo",
    ATTACHED_FILES: "Laudos anexados",
    OPEN_FILE: "Abrir",
    FILE_INVALID: "Arquivo inválido. Anexe um PDF, JPEG ou PNG de até 10 MB.",
    FILE_READ_ERROR: "Não foi possível ler o arquivo selecionado. Tente novamente.",
    FILE_UPLOAD_SUCCESS: "Laudo anexado com sucesso.",
    FILE_UPLOAD_ERROR: "Não foi possível anexar o laudo. Tente novamente.",
    NO_ATTACHED_FILES: "Nenhum laudo anexado.",
    NEW_EVOLUTION: "Nova evolução",
    NO_EVOLUTIONS: "Nenhuma evolução registrada.",
    EVOLUTION_SAVED: "Evolução registrada com sucesso.",
    EVOLUTION_ERROR: "Não foi possível registrar a evolução. Tente novamente.",
    DISCHARGE: "Dar alta",
    DISCHARGE_TITLE: "Alta da internação",
    DISCHARGE_CONDITION: "Condição de saída",
    DISCHARGE_SUMMARY: "Resumo de alta",
    DISCHARGE_REQUIRED: "Para dar alta informe a data, a condição de saída e o resumo de alta.",
    DISCHARGE_CONFIRM: "Ao dar alta, a internação passa a ser um registro clínico definitivo.<br><br>O conteúdo não poderá mais ser editado e novas evoluções não poderão ser registradas.<br><br>Deseja dar alta a este paciente?",
    DISCHARGE_CONFIRM_ACTION: "Dar alta",
    DISCHARGE_SUCCESS: "Alta registrada com sucesso.",
    HOSPITALIZATION_DERIVED_STATUS_HINT: "A internação fica ativa até a alta.",
})
